import { render, staticRenderFns } from "./GAccountInfo.vue?vue&type=template&id=72a05e8a&scoped=true&"
import script from "./GAccountInfo.vue?vue&type=script&lang=ts&"
export * from "./GAccountInfo.vue?vue&type=script&lang=ts&"
import style0 from "./GAccountInfo.vue?vue&type=style&index=0&id=72a05e8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a05e8a",
  null
  
)

export default component.exports